{
  "messages": {
    "list_title": "Message Center",
    "go_to_index": "Back To Messages",
    "mark_all_read": "Mark All Read",
    "manage_messages": "Manage Messages",
    "manage_help_text": "Please choose messages first"
  }
}
